import * as React from 'react'
import styled from 'styled-components'
import { Style } from '../../styles'
import { WidgetSpace } from '../../types'
import WidgetSpaceItem from '../../containers/Widget/WidgetSpaceItem'
import { DragDropContext, Draggable, Droppable, DropResult, ResponderProvided } from '@hello-pangea/dnd'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Style.spacing.x1};
`

interface IProps {
  spaces: WidgetSpace[]
  onChange: (spaces: WidgetSpace[]) => void
}

const WidgetSpaces = (props: IProps) => {
  const { spaces } = props

  const onDragEnd = (result: DropResult, provided: ResponderProvided) => {
    if (!result.destination) {
      return
    }

    const updatedSpaces = Array.from(spaces)
    const [removed] = updatedSpaces.splice(result.source.index, 1)
    updatedSpaces.splice(result.destination.index, 0, removed)

    props.onChange(updatedSpaces)
  }

  const onEnabledChange = (index: number, enabled: boolean) => {
    const updatedSpaces = [...spaces]
    updatedSpaces[index].enabled = enabled
    props.onChange(updatedSpaces)
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId='spaces' direction='vertical'>
        {(provided) => {
          return (
            <Container ref={provided.innerRef} {...provided.droppableProps}>
              {spaces?.map((space, index) => {
                return (
                  <Draggable key={space.type} draggableId={String(space.type)} index={index}>
                    {(provided) => {
                      return (
                        <WidgetSpaceItem
                          key={index}
                          provided={provided}
                          space={space}
                          onEnabledChange={(enabled) => onEnabledChange(index, enabled)}
                        />
                      )
                    }}
                  </Draggable>
                )
              })}
              {provided.placeholder}
            </Container>
          )
        }}
      </Droppable>
    </DragDropContext>
  )
}

export default WidgetSpaces